<div>
    <h4>{{ error.errorMessage}}</h4>
    <div style='text-align: center'><strong><h4>{{error.errorCode}}</h4></strong></div>
    <br><br>
    <div style='text-align: center'>
        <a style='cursor:pointer' (click)='reloadPage()' matTooltip="Reload Page" matTooltipPosition="above"><i class="material-icons" >replay</i><br>reload</a> 
    </div>
</div>